import { Paper as MuiPaper, styled } from '@mui/material';

/**
 * The primary page wrapper for the cancellations journey, using MUIPaper
 */
const PageWrapper = styled(MuiPaper)({
	borderRadius: '8px',
	marginTop: '1em',
	marginBottom: '1em',
});

export default PageWrapper;
